// extracted by mini-css-extract-plugin
export var col = "get-module--col--d634b";
export var format = "get-module--format--2b5d2";
export var get = "get-module--get--63771";
export var list = "get-module--list--fa9e7";
export var mission = "get-module--mission--b7c41";
export var subtitle = "get-module--subtitle--5a78a";
export var target = "get-module--target--4d399";